
import React from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup'; 
import Checked from '../Components/Checked';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export default function CensoSearch(props)
{
    return(
        <Row className="p4">
            <Col xs={8}>
                <InputGroup>
                    <InputGroup.Prepend>
                        <InputGroup.Text id="basic-addon1">
                            <FontAwesomeIcon icon={faSearch}/>
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                    placeholder="Buscar"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                    value={props.search}
                    onChange={(e) => props.setSearch(e.target.value)}
                    onKeyDown={props.entrysearch}
                    />
                    <Button variant='dark' onClick={() => props.SearchQuery()}>Buscar</Button>
                </InputGroup>
            </Col>
            <Col xs={4}>
                <ToggleButtonGroup type="checkbox" className="vac">
                    <ToggleButton variant="outline-dark" 
                                value={true}
                                checked={props.filteron} 
                                onChange={() => props.setFilteron(!props.filteron)}>
                        <Checked ison={props.filteron}/> Filtros
                    </ToggleButton>
                </ToggleButtonGroup>
            </Col>
        </Row>
    );
}